import {Expose} from "class-transformer";
import {CommandPayload} from "./command-payload";
import type {SensitivePayload} from "./sensitive-payload.interface";

/**
 * Payload of `ChangeOwnPasswordCommand`: the current password, which the backend checks (with the
 * brake on password entries), and the new one, which it checks against rule S6. The repetition of
 * the new password is a check of the page only and never travels.
 *
 * Both passwords must not stay on this object: the CommandBus clears them right after the request
 * body was built (`clearSensitiveValues`), and the page clears them again once the command was answered.
 */
export class ChangeOwnPasswordContent extends CommandPayload implements SensitivePayload {

    @Expose()
    public currentPassword: string;

    @Expose()
    public newPassword: string;

    public constructor(currentPassword: string, newPassword: string) {
        super();
        this.currentPassword = currentPassword;
        this.newPassword = newPassword;
    }

    public clearSensitiveValues(): void {
        this.currentPassword = '';
        this.newPassword = '';
    }
}
